import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../../common/breadcrumbs";
import Loader from "../../../../common/loader";
import {formateDate, showStatus } from "../../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { DetailsCenterSpecilization } from "../../../../services/usermgmt.services";

const CenterSpecializationView = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const { center_id } = useLocation().state;
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
    { title: t("Center Management"), url: "/admin/center-management/center/list/1" },
    { title: t("Center Specialization"), url: `/admin/center-management/center/specialization/${center_id}/list/1` },
    { title: t("admin.faq.link_view"), url: "" },
  ];
 


  useEffect(() => {
    DetailsCenterSpecilization(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("View Center Specialization")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        
                        <tr>
                          <th>{t("admin.faq.list_heading_title")} </th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.title
                              ? showdefault.title
                              : "N/A"}
                          </td>
                        </tr>
                        
                        <tr>
                          <th>{t("admin.faq.label_status")}</th>
                          <td>
                            {showdefault && showdefault?.status === 0
                              ? toHtml(showStatus(showdefault.status))
                              : toHtml(showStatus(showdefault.status))}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("admin.list_heading.list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("admin.list_heading.list_heading_modified_date")}</th>
                          <td>
                            {showdefault && showdefault?.updatedAt
                              ? formateDate(showdefault.updatedAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="mt-5">
                      <button
                        className="btn ripple btn-dark"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("admin.button.btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CenterSpecializationView;
